import { render, staticRenderFns } from "./VoteModeration.vue?vue&type=template&id=5eb3163e&scoped=true&"
import script from "./VoteModeration.vue?vue&type=script&lang=js&"
export * from "./VoteModeration.vue?vue&type=script&lang=js&"
import style0 from "./VoteModeration.vue?vue&type=style&index=0&id=5eb3163e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb3163e",
  null
  
)

export default component.exports